// Configuración de API
// La URL del backend se configura mediante variable de entorno
// En desarrollo: REACT_APP_API_URL=http://localhost:3001
// Con Cloudflare: REACT_APP_API_URL=https://tu-backend.trycloudflare.com
// En producción: REACT_APP_API_URL=https://api.tudominio.com

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
export default API_URL;